import React from 'react'
import {BsClipboard} from "react-icons/bs"
function Logo() {
    return (
        <div className='flex flex-row my-auto xl:-ml-0 lg:-ml-0 md:-ml-0 sm:-ml-6 -ml-8'>            
            <BsClipboard className='m-auto mr-0 ml-0'/>
            <p className='select-none font-bold m-auto ml-1'>AFODA</p>
        </div>
    )
}

export default Logo
